module.exports = __webpack_public_path__ + "static/media/gal0208.db735bd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal02/gal0208.jpg
// module id = 444
// module chunks = 0